import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { useNavigate } from "react-router";

import { BouncingCheck } from "../../../../OrderOverview/components/PaymentSection/PaymentSuccessFull/BouncingCheck";
import { StyledSuccessContainer } from "../../../../OrderOverview/components/PaymentSection/styled";

export function UpdateSuccessFull({
  publicContact,
  isInternalUser,
  orderId,
  onReturnClick,
}: {
  publicContact: any;
  isInternalUser: boolean;
  orderId: string;
  onReturnClick: () => void;
}) {
  const navigate = useNavigate();
  return (
    <StyledSuccessContainer className="w-full flex flex-column align-items-center pt-6 px-3">
      <div className="flex relative">
        <BouncingCheck />
        <p className="text-md gray line-height-3 message">Great Job!</p>
      </div>
      <p className="text-4xl font-semibold highlighted mt-1 text-center">
        Your Card Details are Updated!
      </p>
      <Button
        className="p-button p-button-outlined mt-5"
        onClick={onReturnClick}
      >
        Back to details
      </Button>

      <Divider type="solid" className="mt-5" />
      <p className="highlighted font-medium text-xl line-height-3">
        Questions about your payments?
      </p>
      <p className="line-height-3 mt-1 text-center">
        Reach out to our support team anytime.
      </p>
      <div className="flex justify-content-center gap-4 mt-4">
        {publicContact().isVisible && (
          <div className="text-center flex flex-column">
            <p className="text-sm line-height-3 font-semibold">
              {publicContact().name}
            </p>
            <p className="text-sm line-height-3 gray">{publicContact().role}</p>
            <p className="text-sm line-height-3 gray">
              {publicContact().phone}
            </p>
          </div>
        )}

        <div className="text-center 1 flex flex-column">
          <p className="text-sm line-height-3 font-semibold">Brooke Leblanc</p>
          <p className="text-sm line-height-3 gray">Clear Health Support</p>
          <p className="text-sm line-height-3 gray">888-918-2522</p>
        </div>
      </div>
    </StyledSuccessContainer>
  );
}
